import { AlertDTO } from '@meshwatch/types';

import { EmailDispatcher } from '../shared/aws/ses';

class EmailNotificationService {
  private readonly emailDispatcher: EmailDispatcher;

  public constructor(emailDispatcher: EmailDispatcher) {
    this.emailDispatcher = emailDispatcher;
  }

  public notify = (alert: AlertDTO, timestamp: Date) => {
    const text = JSON.stringify({ ...alert, timestamp });
    return this.emailDispatcher.send({
      text,
      html: text,
      recipient: 'test@gmail.com',
      subject: 'Monitor alert violation',
      source: 'alert@meshwatch.dev',
    });
  };
}

export default EmailNotificationService;
